import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../services/api.service';
@Component({
  selector: 'app-callback',
  template: `<p>Response received from Authorization server</p>`
})
export class CallbackComponent implements OnInit {

  constructor(private apiService: ApiService, private route: ActivatedRoute) { }

  ngOnInit() {
    const fragmentSplits = this.route.snapshot.fragment.split('&');
    fragmentSplits.forEach(pair => {
      const parts = pair.split('=');
      if (parts[0] === 'id_token') {
        this.apiService.storeNewIdToken(parts[1]);
      }
    });
   
  }

}
